import GeoLocation from './GeoLocation'
import Images from './Images'
import ObservationSet from './ObservationSet'
import TextArea from './TextArea'
import DateTime from './DateTime'
import YesNo from './YesNo'
import Hidden from './Hidden'
import Tags from './Tags'

export default new Map([
    ['geolocation', GeoLocation],
    ['images', Images],
    ['observation-set', ObservationSet],
    ['text-area', TextArea],
    ['date-time', DateTime],
    ['yes-no', YesNo],
    ['hidden', Hidden],
    ['tags', Tags],
])
